<template>
  <div class="cart_wrapp">
    <div class="product_iformation">

      <div class="product_iformation_grid cart_header">
        <p>Proizvod</p>
        <div></div>
        <p>Cena</p>
        <p>Količina</p>
        <p class="last_right">Ukupno</p>
        <div></div>
      </div>

      <div class="product_iformation_grid product" v-for="(item, index) in getCartItems" :key="index">
        <a :href="item.model.path" class="product_img">
          <img :src="item.model.cartImage" :alt="item.model.short" width="270" height="400">
          <h2>{{ item.model.html_title }} {{ item.name }}</h2>
        </a>
        <div class="left">
          <h2><a :href="item.model.path">{{ item.model.html_title }} {{ item.name }}</a></h2>
        </div>
        <p>{{ formatPrice(item.model.discountedPrice) }} rsd</p>
        <div class="quantity">
          <button @click="reduce(item)" aria-label="smanji količinu">-</button>
          <p>{{ item.qty }}</p>
          <button @click="increase(item)" aria-label="povećaj količinu">+</button>
        </div>
        <p class="last_right">{{ formatPrice(item.model.discountedPrice * item.qty) }} rsd</p>

        <remove-icon :index="index" :product="item.model">
        </remove-icon>
      </div>

      <a class="continue_shopping" :href="domain + link">DODAJTE JOŠ PROIZVODA</a>
    </div>

    <div class="total_information">
      <div class="total_information_header">
        <p>Kod za popust</p>
      </div>
      <input type="text" placeholder="Unesite kod za popust" v-model="coupon" />
      <button class="use_coupon" @click="checkCoupon">ISKORISTITE POPUST</button>

	    <div class="cart_total">
		    <p><span>Ukupno:</span> <span>{{ formatPrice(getSubTotalPrice) }} rsd</span></p>
		    <p v-if="getCoupon"><span>Kupon: {{ getCoupon.code }}</span><span>- {{ formatPrice(getCoupon.discountPrice) }}
            rsd</span>
		    </p>
		    <p v-else><span>Popust:</span><span>- {{ formatPrice(getSubTotalPrice - getTotalPrice) }}
            rsd</span>
		    </p>
		    <p><span>Sveukupno:</span> <span>{{ formatPrice(getTotalPrice) }} rsd</span></p>
	    </div>

      <p class="delivery" v-if="getTotalPrice < 3000">Transport i dostava: Naplaćuje se po <a
          href="http://www.postexpress.rs/struktura/lat/cenovnik/cenovnik-unutrasnji-saobracaj.asp" target="_blank"
          rel="noopener">cenovniku</a> kurirske službe</p>
      <p v-else class="delivery">Transport i dostava: Besplatna</p>

      <a class="buy" :href="domain + 'podaci'">KUPITE</a>
    </div>
  </div>
</template>

<script>

import accounting from 'accounting';

export default {
  name: "ShoppingCart",

  data() {
    return {
      domain: domain,
      coupon: null
    }
  },

  props: [
    'link'
  ],


  computed: {

    /**
     * Retrieve cart items from vuex store
     * That means on every change of vuex state, retrieve changes...
     */
    getCartItems() {

      return this.$store.getters['Cart/getCartItems'];
    },

    /**
     * Retrieve cart items count from vuex store
     */
    getCartItemsCount() {
      return this.$store.getters['Cart/getItemCount'];
    },

    /**
     * Retrieve cart items total price from vuex store
     */
    getTotalPrice() {
      return this.$store.getters['Cart/getTotalPrice'];
    },

    /**
     * Retrieve cart items sub-total price from vuex store
     */
    getSubTotalPrice() {
      return this.$store.getters['Cart/getSubTotalPrice'];
    },

    /**
     * Retrieve cart items total price without pdv from vuex store
     */
    getTotalWithoutPDV() {
      return this.$store.getters['Cart/getTotalWithoutPDV'];
    },

    /**
     * Retrieve cart items total pdv from vuex store
     */
    getTotalPDV() {
      return this.$store.getters['Cart/getTotalPDV'];
    },

    /**
     * Retrieve coupons code and total discount
     */
    getCoupon() {
      return this.$store.getters['Cart/getCoupon'];
    }

  },

  methods: {

    /**
     * Increase products quantity.
     */
    increase(item) {
      item.qty++;

      this.updateShoppingCart(item);
    },

    /**
     * Reduce products quantity.
     */
    reduce(item) {
      item.qty--;

      this.updateShoppingCart(item);
    },

    /**
     * Update Shopping cart by sending request to backend.
     *
     * @param item
     */
    updateShoppingCart(item) {

      axios.post('/dodaj-u-korpu/' + item.rowId, { qty: item.qty })
        .then(response => {

          this.$toasted.global.toastSuccess({ message: response.data.message });

          // Update vuex store
          this.$store.dispatch('Cart/changeCartItems', response.data.cartItems);
          this.$store.dispatch('Cart/changeItemCount', response.data.cartItemsCount);
          this.$store.dispatch('Cart/changeTotalPrice', response.data.totalPrice);
          this.$store.dispatch('Cart/changeSubTotalPrice', response.data.subTotalPrice);
          this.$store.dispatch('Cart/changeTotalWithoutPDV', response.data.totalWithoutPDV);
          this.$store.dispatch('Cart/changeTotalPDV', response.data.totalPDV);
          this.$store.dispatch('Cart/changeCoupon', response.data.coupon);
        })
        .catch(error => {

          item.qty--;

          // Update vuex store
          this.$toasted.global.toastError({ message: error.response.data.message });
          this.$store.dispatch('Cart/changeCartItems', error.response.data.cartItems);
          this.$store.dispatch('Cart/changeItemCount', error.response.data.cartItemsCount);
          this.$store.dispatch('Cart/changeTotalPrice', error.response.data.totalPrice);
          this.$store.dispatch('Cart/changeSubTotalPrice', error.response.data.subTotalPrice);
          this.$store.dispatch('Cart/changeTotalWithoutPDV', error.response.data.totalWithoutPDV);
          this.$store.dispatch('Cart/changeTotalPDV', error.response.data.totalPDV);
          this.$store.dispatch('Cart/changeCoupon', error.response.data.coupon);

        })
    },

    /**
     * Format price.
     *
     * @param value
     */
    formatPrice(value) {

      return accounting.formatMoney(value, '', 2, '.', ',')
    },

    /**
     * Send request to check if coupon code is valid.
     */
    checkCoupon() {
      axios.post('korpa/kupon', { code: this.coupon })
        .then(response => {

          this.$toasted.global.toastSuccess({ message: 'Uspesno primenjen kupon' });

          this.$store.dispatch('Cart/changeTotalPrice', response.data.totalPrice);
          this.$store.dispatch('Cart/changeCoupon', response.data.coupon);
        })
        .catch(error => {

          // Return code of error from Coupon Request if code doesnt pass validaton.
          if (error.response.data.message === 'The given data was invalid.') {
            this.$toasted.global.toastError({ message: error.response.data.errors.code[0] });
          } else {
            // Else return message from controller.
            this.$toasted.global.toastError({ message: error.response.data.message });
          }
          this.$notify(e.response.data.message, 'error');
        })
    }
  },
}

</script>
